import { RefreshCw, X } from 'lucide-react'
import { useRegisterSW } from 'virtual:pwa-register/react'
import { Button } from '@/components/ui/Button'

/**
 * Предложение обновиться вместо тихой подмены версии.
 *
 * registerType: 'prompt' оставляет новый Service Worker в waiting, пока
 * пользователь не согласится. Это единственный способ не потерять
 * недописанное сообщение и недостримленный ответ ИИ: обновление
 * перезагружает вкладку.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW()

  if (!needRefresh) return null

  return (
    <div
      role="status"
      className="lc-no-print fixed inset-x-0 bottom-0 z-50 px-3 pb-[calc(env(safe-area-inset-bottom)+0.75rem)] md:inset-x-auto md:right-4 md:bottom-4 md:px-0"
    >
      <div className="mx-auto flex max-w-md items-center gap-3 rounded-bubble border border-divider bg-surface p-4 shadow-lg">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
          <RefreshCw size={22} />
        </span>

        <div className="min-w-0 flex-1">
          <p className="text-base font-semibold text-gray-900">LightChat стал ещё лучше</p>
          <p className="text-sm text-muted">Мы подготовили для вас полезные улучшения. Сохраните начатое и обновите страницу — это займёт всего несколько секунд.</p>
        </div>

        <Button size="sm" onClick={() => void updateServiceWorker(true)}>
          Обновить
        </Button>

        <button
          type="button"
          onClick={() => setNeedRefresh(false)}
          aria-label="Отложить обновление"
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-muted hover:bg-background"
        >
          <X size={20} />
        </button>
      </div>
    </div>
  )
}
